import { JsonConfiguration } from "./json-configuration-type";
import { LogService } from "../log";

class JsonConfigurationServiceController {
	constructor() {}

	getConfiguration(tagName: string): JsonConfiguration | undefined {
		const configElement: HTMLElement = document.getElementById(tagName);

		if (configElement) {
			const configContent: JsonConfiguration = JSON.parse(configElement.innerHTML) as JsonConfiguration;

			LogService.log.info("Found JSON configuration on page:", configContent);

			return configContent;
		} else {
			LogService.log.info("No JSON configuration found on page.");

			return undefined;
		}
	}
}

export const JsonConfigurationService = new JsonConfigurationServiceController();
